module.exports = __webpack_public_path__ + "static/img/jr_sc@2x.04e6aba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jr_sc@2x.png
// module id = V1YU
// module chunks = 2